module.exports = __webpack_public_path__ + "img/enviar-practicas.91cfccfc.png";